import React from "react"
import { navigate } from "gatsby"

import {
  SimpleAuthorsContainer,
  CardDescription,
  NextBtnSimpleItemContainer,
  TitleSimpleItem,
  PreviewText,
  SimpleCardContainer,
  AuthorLabel,
  ImageCroppedSimpleItem,
  MainContainer,
  NextBtnContainer,
  ReadNextContainer,
  CardContainer,
  TextContainer,
  Title,
  ImageCropped,
  NextBtn,
  AuthorName,
  ImageLink,
} from "./styles"

const Card = ({ headlineCard, byline, showImage, link }) => (
  <CardContainer>
    {showImage}
    <TextContainer>
      <Title href={link}>{headlineCard}</Title>
      <AuthorName>{byline}</AuthorName>
    </TextContainer>
  </CardContainer>
)

const Recirculation = ({ elRef, items = [], category = "" }) => {
  const imageSizes = [
    {
      query: 576,
      width: 300,
      height: 231,
      transforms: `c_fill,g_auto,w_300,h_231,q_auto,f_auto,fl_lossy`,
    },
    {
      query: 0,
      width: 300,
      height: 231,
      transforms: `c_fill,g_auto,w_300,h_231,q_auto,f_auto,fl_lossy`,
    },
  ]

  const getImage = ({ simpleItem = false, imageCrops, link }) => {
    let image
    if (simpleItem) {
      image = (
        <ImageCroppedSimpleItem fetchpriority="high" imageData={imageCrops} sizes={imageSizes} />
      )
    } else {
      image = <ImageCropped fetchpriority="high" imageData={imageCrops} sizes={imageSizes} />
    }
    return <ImageLink href={link}>{image}</ImageLink>
  }

  if (items?.length === 1) {
    const node = items[0]

    return (
      <SimpleCardContainer ref={elRef} data-exp-id="promotional-recirculation">
        <CardDescription>
          <NextBtnSimpleItemContainer>
            <NextBtn onClick={() => navigate(`/${category?.toLowerCase()}`)}>Read Next</NextBtn>
          </NextBtnSimpleItemContainer>
          <TitleSimpleItem href={node.url}>{node.headlineCard}</TitleSimpleItem>
          <PreviewText
            dangerouslySetInnerHTML={{ __html: node.subheadline.childMarkdownRemark.html }}
          />
          <SimpleAuthorsContainer>
            <AuthorLabel>by</AuthorLabel>
            <AuthorName simple>{node.byline}</AuthorName>
          </SimpleAuthorsContainer>
        </CardDescription>
        <CardDescription image>
          {getImage({
            simpleItem: true,
            imageCrops: node.imageCrops,
            link: node.url,
          })}
        </CardDescription>
      </SimpleCardContainer>
    )
  }

  return (
    <MainContainer ref={elRef} data-exp-id="promotional-recirculation">
      <NextBtnContainer>
        <NextBtn moreThanOneCard onClick={() => navigate(`/${category?.toLowerCase()}`)}>
          Read Next
        </NextBtn>
      </NextBtnContainer>
      <ReadNextContainer>
        {items.slice(0, 3).map((node, index) => (
          <Card
            key={`archive-article-${node.itemId}`}
            index={index}
            {...node}
            category={node.category}
            link={node.url}
            showImage={getImage({
              moreThanTwoCards: items.length > 2,
              imageCrops: node.imageCrops,
              link: node.url,
            })}
          />
        ))}
      </ReadNextContainer>
    </MainContainer>
  )
}

export default Recirculation
